import React from 'react';
import './Collections.css';
import { MdErrorOutline } from 'react-icons/md';
import { Availability } from '../../client/core';

const MAX_LEAD_TIME_HOURS = 336;

const PRESETS: { hours: number; label: string }[] = [
    { hours: 24, label: '24h' },
    { hours: 48, label: '48h' },
    { hours: 72, label: '72h' },
    { hours: 168, label: '1 week' }
];

export interface LeadTimeProps {
    availability: Availability;
    onChange: (availability: Availability) => void;
}

const LeadTime: React.FC<LeadTimeProps> = ({ availability, onChange }) => {
    const leadTimeHours = availability?.leadTimeHours ?? 0;

    const setHours = (hours: number) => {
        onChange({
            ...availability,
            leadTimeHours: hours
        });
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const hours = value === '' ? 0 : Math.max(0, parseInt(value, 10) || 0);

        setHours(hours);
    };

    return (
        <div className="cp-field">
            <label className="cp-field-label" htmlFor="cp-lead-time">
                Lead time
            </label>

            <p className="cp-field-hint">
                Customers must order at least this many hours before collecting from this point.
            </p>

            <div className="cp-lead-row">
                <input
                    id="cp-lead-time"
                    type="number"
                    data-testid="lead-time-input"
                    className="lead-time-input"
                    value={leadTimeHours}
                    onChange={handleChange}
                    min={0}
                    max={MAX_LEAD_TIME_HOURS}
                />
                <span className="cp-lead-unit">hours</span>

                {PRESETS.map(preset => (
                    <button
                        key={preset.hours}
                        type="button"
                        className={`cp-preset${leadTimeHours === preset.hours ? ' cp-preset-on' : ''}`}
                        onClick={() => setHours(preset.hours)}
                        data-testid={`lead-time-preset-${preset.hours}`}
                        aria-pressed={leadTimeHours === preset.hours}
                    >
                        {preset.label}
                    </button>
                ))}
            </div>

            {leadTimeHours > MAX_LEAD_TIME_HOURS && (
                <div className="cp-field-error" data-testid="lead-time-error">
                    <MdErrorOutline size={15} />
                    Enter a whole number of hours between 0 and {MAX_LEAD_TIME_HOURS}
                </div>
            )}
        </div>
    );
};

export default LeadTime;
